import React from "react";
import { useEffect } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import upchbgred from "../assets/iconos/upchbgred.png";
import useAuth from "../hooks/useAuth";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { listado_img_login } from "../services/public/Public";
const Banner = () => {
  let { listadoImgLogin, setListadoImgLogin } = useAuth();
  let { setLoading } = useProcesoMatricula();

  useEffect(() => {


    try {
      listado_img_login(setListadoImgLogin, setLoading);
    } catch (error) {
    } finally {

    }

    document.querySelector("#button0")?.click();
  }, []);

  useEffect(() => {
    document.querySelector("#button0")?.click();
  }, [listadoImgLogin]);

  return (
    <div className="col-md-6 col-lg-6 d-sm-none d-md-block px-0">
      <div
        id="carouselExampleCaptions"
        className=" d-sm-none d-md-block carousel slide"
        data-bs-ride="carousel"
      >
        {
          listadoImgLogin.length > 0 ? (
            <div
              id="carouselExampleDark"
              className="d-sm-none d-md-block carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-indicators">
                {listadoImgLogin.map((data, index) => {
                  if (index == 0) {
                    return (
                      <button
                        key={index}
                        type="button"
                        data-bs-target="#carouselExampleDark"
                        data-bs-slide-to={index}
                        className="active"
                        aria-current="true"
                        aria-label={`Slide ${index + 1}`}
                        id={`button${index}`}
                      />
                    );
                  } else {
                    return (
                      <button
                        key={index}
                        type="button"
                        data-bs-target="#carouselExampleDark"
                        data-bs-slide-to={index}
                        aria-label={`Slide ${index + 1}`}
                        id={`button${index}`}
                      />
                    );
                  }
                })}

              </div>
              <div className="carousel-inner">
                {listadoImgLogin.map((data, index) => {
                  if (index == 0) {
                    return (
                      <div
                        className={`carousel-item active`}
                        data-bs-interval={1500}
                        key={index}
                      >
                        <img src={data.durl} className="d-block w-100" alt="..." />
                        <div className="carousel-caption d-none d-md-block mb-4">
                          <h4 className="text-start mb-0">
                            <span
                              dangerouslySetInnerHTML={{ __html: data?.dtexto1 ?? "" }}
                            />
                          </h4>
                          <h3 className="text-start fw-bold">{data.dtexto2}</h3>
                        </div>
                      </div>
                    );
                  }
                  else {
                    return (
                      <div
                        className={`carousel-item`}

                        key={index}
                      >
                        <img src={data.durl} className="d-block w-100" alt="..." />
                        <div className="carousel-caption d-none d-md-block mb-4">
                          <h4 className="text-start mb-0">
                            <span
                              dangerouslySetInnerHTML={{ __html: data?.dtexto1 ?? "" }}
                            />
                          </h4>
                          <h3 className="text-start fw-bold">{data.dtexto2}</h3>
                        </div>
                      </div>
                    );
                  }

                })}

              </div>

            </div>

          ) : (
            <div className="position-loadi">
              <div className="custom-loader"></div>

            </div>
          )


        }
      </div>


    </div>
  );
};

export default Banner;
